// extracted by mini-css-extract-plugin
module.exports = {"bgBlue":"faqs-module--bgBlue--EVRoS","bgYellow":"faqs-module--bgYellow--3vOAi","container":"faqs-module--container--mfBOX","category":"faqs-module--category--19cg_"};